import React from 'react';
import { useTranslation } from 'react-i18next';

import './Message.scss';
import Header from '../../../Components/Header';
import { FooterMenu } from '../../../Components/FooterMenu';
import { MessageList } from '../../../Components/Admin/MessageList';

const ManagerMessageList = () => {
  const { t } = useTranslation();

  return (
    <div className='agent_layout'>
      <Header name={t('menu.messages')} />
      <div className='agent_body'>
        <MessageList />
      </div>

      <FooterMenu isManager={true}/>
    </div>
  );
};

export default ManagerMessageList;
